export default `float e,s;
  e=s=2.;
  for(int i=0;i++<6;s*=2.,p*=2.)
    p=.1-abs(abs(p)-.2),
    p=p.x<p.y?p.zxy:p.zyx,
    e=min(e,(length(vec2(length(p.xy)-1.,p.z)))/s+5e-4);
  return e;
}`